// Firebase Web SDK config for app-academy-website.
// These keys are designed to be public — Firebase security is enforced
// via Security Rules in the Console, not by hiding the config.
export const firebaseConfig = {
  apiKey: 'AIzaSyAfvISNNTxejijpFQwNCpXrdo71ZJHvt6A',
  authDomain: 'app-academy-website.firebaseapp.com',
  projectId: 'app-academy-website',
  storageBucket: 'app-academy-website.firebasestorage.app',
  messagingSenderId: '560307749491',
  appId: '1:560307749491:web:0b03233b74f32f75cfe006',
  measurementId: 'G-0590H4LCFP',
};
